var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcCloseModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 225"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 275",
    x: 1.63574,
    y: 0.222168,
    width: 20,
    height: 2,
    rx: 1,
    transform: "rotate(45 1.63574 0.222168)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 276",
    width: 20,
    height: 2,
    rx: 1,
    transform: "matrix(-0.707107 0.707107 0.707107 0.707107 14.3635 0.222168)",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCloseModal);
export default __webpack_public_path__ + "static/media/ic_close_modal.e5b12000855bd482128b4022fe3388a2.svg";
export { ForwardRef as ReactComponent };